import { ReactChild, ReactElement, ReactNode } from "react";

import { useAuthContext } from "../../authHelper";

export default function MainContainer({
  header,
  footer,
  children,
}: {
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactChild;
}): ReactElement {
  const { user } = useAuthContext();
  const isUserEmployee = user ? user.isEmployee : false;
  return isUserEmployee ? (
    <>
      <div className="tw-flex">
        {header}
        <main className="sui-u-main-global tw-flex-grow" role="main-container">
          <div className="inner-main">{children}</div>
          {footer}
        </main>
      </div>
    </>
  ) : (
    <>
      {header}
      <main className="sui-u-main" role="main-container">
        {children}
      </main>
      {footer}
    </>
  );
}
